import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS.js';
import PageNewsletterCampaignSettings from '../present/PageNewsletterCampaignSettings'
import getData from '../../../functions/getData.js';
import { NEWSLETTERSERVER, THEME } from '../../../constants/state.js';
import { newsletterUpdateCampaignRequest, requestAllData } from '../../../actions/index.js';
import { push } from 'connected-react-router';
import { generatePath } from 'react-router-dom';

const mapStateToProps = (state, ownProps) => ({
    itemData: state.getIn(['newsletterServerData', 'campaigns', 'data', 'items', ownProps.match.params.campaignId]),
    themeData: getData(state, THEME),
    translationStrings: state.getIn(['translation', 'strings']),
    currentLang: state.getIn(['translation', 'currentLang']),
    translationDebug: state.getIn(['translation', 'debug']),
    sendStatus: state.getIn([NEWSLETTERSERVER, 'campaigns', 'status']),
    sendError: state.getIn([NEWSLETTERSERVER, 'campaigns', 'error']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateSettings: (itemData) => {
        dispatch(newsletterUpdateCampaignRequest(ownProps.match.params.campaignId, itemData))
    },

    onResetSettings: (loadAll = false) => {
        const closePagePath = generatePath(ownProps.goBackPath, ownProps.match.params)
        dispatch(push(closePagePath))

        if(loadAll) {
            dispatch(requestAllData())
        }
    },

    onSwitchToPreview: () => {
        const closePagePath = generatePath(ownProps.goBackPath, ownProps.match.params)
        dispatch(push(closePagePath + '/settings/vorschau'))
    },
})

const PageNewsletterCampaignSettingsContainer = ({
    itemData, 
    themeData,
    translationStrings,
    currentLang,
    translationDebug,
    goBackPath, 
    match, 
    sendStatus,
    sendError,
    onSwitchToPreview,
    onResetSettings,
    onUpdateSettings
}) => {

    return <PageNewsletterCampaignSettings
        itemData={itemData}
        themeData={themeData}
        translationStrings={translationStrings}
        currentLang={currentLang}
        translationDebug={translationDebug}
        goBackPath={goBackPath}
        match={match}
        sendStatus={sendStatus}
        sendError={sendError}
        onSwitchToPreview={onSwitchToPreview}
        onResetSettings={onResetSettings}
        onUpdateSettings={onUpdateSettings}
    />
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PageNewsletterCampaignSettingsContainer))

